module.exports = __webpack_public_path__ + "media/images/mail_image-37623384221123111a14bdfea9aee381.svg";